import React from 'react'
import Ban from "./Banner"
import Ban2 from "./Banner2"
import Abc from "./Footer"

function home() {
  return (
    <div>    
  <Ban/>
  <Ban2/>
  <Abc/>
    </div>
  )
}

export default home